import React, { useCallback, useEffect, useState } from 'react';

import { AppContext } from '../provider/AppContextProvider';
import { CmpProvider } from '../helper/enums';
import { Article, Subscription } from '../helper/interfaces';
import { useUser, useUserValidator} from '../lib/useUser';
import UserSignedOut from './user/UserSignedOut';
import UserRegister from './user/UserRegister';
import Modal from './ui/Modal';
import { getIApTermsId, getPianoAid, getPianoIapPlusHalfYearProductId, getPianoIapPlusMonthlyProductId, getPianoIapPlusYearlyProductId, getPianoIapPurProductId, getPianoPlusOfferId, getPianoPlusTemplateId, getPianoPurOfferId, getPianoPurTemplateId, getPianoScriptUrl, getIApTermsIdAndroid } from '../helper/url';
import { closePianoOffer, term } from '../helper/piano';
import PianoScript from './PianoScript';
import Link from 'next/link';
import { logBugsnagError } from '../lib/bugsnag';
import { PianoSwitchConfigurationInterface, TrackingInformationInterface } from '../helper/PageInformationInterface';
import { trackSubscriptionWithSnowPlow } from '../helper/snowplow';

declare global {
  interface Window {
    ATInternet: any;
    _atiHasConsent?: boolean
    __cmp: any;
    showPurPianoExperience: Function;
    showLogin: Function;
    startInAppPurchase: (data: { aId: string, termId: string, userToken: string, apiBaseUrl: string }, trackingInformation?: TrackingInformationInterface) => void
    startInAppPurchaseAndroid: (data: { productId: string, trackingInformation?: TrackingInformationInterface }) => void
    inAppPurchaseCanceled: (termId: string) => void;
    restoreInAppPurchase: () => void
  }
}
interface Data {
  article?: Article,
  trackingInformation?: TrackingInformationInterface;
  showOffer: boolean;
  pianoSwitchConfiguration?: PianoSwitchConfigurationInterface
}

export default function Tracking(props: Data) {
  const { subscription, validateSubscription, setSubscription, pianoInitialized, setPianoInitialized } = React.useContext(AppContext);

  const [offerParams, setOfferParams] = useState<any>()

  const [showLoginOverlay, setShowLoginOverlay] = useState(false)
  const [showRegister, setShowRegister] = useState(false)

  const [user, setUser] = useUser()
  const [validate] = useUserValidator(user, setUser)

  const checkoutCustomEvent = useCallback((params) => {
    let tp = window["tp"] || [];

    const pur = params && params.params && params.params.purabo != undefined
    if(pur) {
      setOfferParams({ templateId: getPianoPurTemplateId()})
    }
    else {
      setOfferParams(params)
    }
    
    if(params.eventName == "modal-login") {
      window.__cmp("close");
      tp.offer.close()
      setShowLoginOverlay(true)
    }
    else if(params.eventName == "modal-back-link") {
      tp.offer.close()
      if(pur) {
        window.__cmp("showScreen");
      }
    }
    else if(params.eventName == 'modal-restore-iap') {
      if(window.restoreInAppPurchase) {
        window.restoreInAppPurchase()
      }
    }
  }, [])
  
  const startCheckout = useCallback((params) => {
    // console.log("startCheckout")
    // console.log(params)
    // logBugsnagError("startCheckout", (event) => {
    //     event.addMetadata('params', { params: params })
    //   })
    if(window.startInAppPurchase) {
      let productId = getIApTermsId(params.termId)
      //preSetSubscription(productId)
      // console.log({
      //   aId: getPianoAid(),
      //   termId: productId,
      //   userToken: (user && user.tokenId) ? user.tokenId : '',
      //   apiBaseUrl: process.env.NEXT_PUBLIC_PIANO_API_URL
      // })
      window.startInAppPurchase({
        aId: getPianoAid(),
        termId: productId,
        userToken: (user && user.tokenId) ? user.tokenId : '',
        apiBaseUrl: process.env.NEXT_PUBLIC_PIANO_API_URL ?? ''
        }, props.trackingInformation)
    }
    else if(window.startInAppPurchaseAndroid) {
      let productId = getIApTermsIdAndroid(params.termId)
      if(!productId) {
        logBugsnagError("startCheckout: productId not found", (event) => {
          event.addMetadata('params', { params: params })
        })
        return;
      }
      else {
        window.startInAppPurchaseAndroid({
          productId: productId,
          trackingInformation: props.trackingInformation,
        })
      }
    }
  }, [props.trackingInformation])// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    window.tikPianostartCheckout = startCheckout
  }, [startCheckout])

  const checkoutComplete = useCallback(async (params) => {
      logBugsnagError("checkoutComplete", (event) => {
        event.addMetadata('params', { params: params })
      })
      const pianoTerm = await term(params.termId)
      if(pianoTerm?.term?.name) {
        trackSubscriptionWithSnowPlow(pianoTerm?.term?.name, `${params.chargeAmount}${params.chargeCurrency}`, pianoTerm?.term?.type);
      }
      else {
        trackSubscriptionWithSnowPlow(params.termId, `${params.chargeAmount}${params.chargeCurrency}`, params.type);
      }
    validateSubscription(undefined, undefined)
  }, [validateSubscription])

  useEffect(() => {
    window.tikPianocheckoutComplete = checkoutComplete
  }, [checkoutComplete])

  const showPiano = useCallback(() => {
    // console.log("showPiano")
    let tp = window["tp"] || [];
    if(tp && tp.setExternalJWT && user && user.tokenId) {
      // console.log("setting tokenId " + user.tokenId)
      tp.setExternalJWT(user.tokenId)
    }

    if(!subscription.validated) {
      validateSubscription(undefined, undefined)
    }
    if(subscription.validated && !(subscription.nnPlusApp || subscription.nnPlusWeb) && props.article && props.article.paid && !props.pianoSwitchConfiguration?.paywallOff) {
      // if(tp && tp.setTags && props.article && props.article.paid) {
      //   tp.setTags([`contentId:${props.article.id}`,`contentPatch:Interview`,"contentState:premium","contentType:Artikelseite"]);
      // }
      // else if(tp && tp.setTags) {
      //   tp.setTags([])
      // }
      // if(tp && tp.offer) {
      //   tp.offer.show({
      //     offerId: getPianoPlusOfferId(),
      //     showCloseButton: !1,
      //     templateId: getPianoPlusTemplateId()
      //   })
      // }
    }
  }, [subscription, props.article, validateSubscription, user])

  useEffect(() => {
    window.tikPianoinit = () => {
      if(props.article && props.article.paid) {
        if(!(subscription.nnPlusApp || subscription.nnPlusWeb)) {
          showPiano() 
        }

      }
    }
  }, [showPiano,  props.article, subscription])

  useEffect(() => {
    if(subscription.validated && (subscription.nnPlusApp || subscription.nnPlusWeb) && props.article && props.article.paid) {
      closePianoOffer()
    }
  }, [subscription, props.article])

  useEffect(() => {
    if(props.showOffer) {
      showPiano()
    }
  }, [props.showOffer, showPiano])

  const showOfferExecute = () => {
    // let tp = window["tp"] || [];
    // if(tp && tp.offer) {
    //   tp.offer.show({
    //     offerId: getPianoPlusOfferId(),
    //     showCloseButton: !1,
    //     templateId: getPianoPlusTemplateId()
    //   })
    // }
  }

  const showPurOffer = () => {
    let tp = window["tp"] || [];
    if(tp && tp.offer) {
      window.__cmp("close");
      tp.offer.show({
        offerId: getPianoPurOfferId(),
        showCloseButton: !1,
        templateId: getPianoPurTemplateId()
      })
    }
  }

  useEffect(() => {
    window.showPurPianoExperience = () => {showPurOffer()}
    window.showLogin = () => {
      window.__cmp("close");
      let tp = window["tp"] || [];
      closePianoOffer()
      setShowLoginOverlay(true)
      setOfferParams({ templateId: getPianoPurTemplateId()})
    }
  }, []);

  const validateLoginParams = useCallback(async(tokenId) => {
    let tp = window["tp"] || [];
    if(tp && tp.setExternalJWT) {
      closePianoOffer()
      tp.setExternalJWT(tokenId)
    }

    if(tokenId) {
      //validate subscription
      let updatedSubscription = await validateSubscription(undefined, tokenId) as Subscription
      if(updatedSubscription.purApp || updatedSubscription.purWeb) {
        setShowLoginOverlay(false)
        return;
      }
    }
    
  
    if(offerParams && offerParams.templateId == getPianoPurTemplateId()) {
      showPurOffer()
    }
    else {
      showOfferExecute()
    }
  }, [offerParams])

  function isPaidProductId(productId): boolean {
    return productId == getPianoIapPlusMonthlyProductId() || productId == getPianoIapPlusHalfYearProductId() || productId == getPianoIapPlusYearlyProductId()
  }

  function isPurProductId(productId): boolean {
    return productId == getPianoIapPurProductId()
  }

  const preSetSubscription = useCallback((productId) => {
    if(isPaidProductId(productId)) {
      // console.log("setSubscription.1")
      setSubscription({
        ...subscription,
        nnPlusApp: true
      })
    }
    if(isPurProductId(productId)) {
      // console.log("setSubscription.2")
      setSubscription({
        ...subscription,
        purApp: true
      })
    }
  }, [subscription, setSubscription])

  useEffect(() => {
    window.tikPianocheckoutCustomEvent = checkoutCustomEvent
  }, [checkoutCustomEvent])

  const loginRequired = useCallback((params) => {
    if((props.article && props.article.paid) || params && params.templateId == getPianoPurTemplateId()) {
      let tp = window["tp"] || [];

      if(window.startInAppPurchase) {
        let productId = getIApTermsId(params.termId)
        //preSetSubscription(productId)
        // console.log("startInAppPurchase")
        // console.log(params)
        // console.log({
        //   aId: getPianoAid(),
        //   termId: productId,
        //   userToken: (user && user.tokenId) ? user.tokenId : '',
        //   apiBaseUrl: process.env.NEXT_PUBLIC_PIANO_API_URL
        // })
        window.startInAppPurchase({
          aId: getPianoAid(),
          termId: productId,
          userToken: (user && user.tokenId) ? user.tokenId : '',
          apiBaseUrl: process.env.NEXT_PUBLIC_PIANO_API_URL ?? ''
          }, props.trackingInformation)
      }
      else if(window.startInAppPurchaseAndroid) {
        let productId = getIApTermsIdAndroid(params.termId)
        if(!productId) {
          logBugsnagError("loginRequired: productId not found", (event) => {
            event.addMetadata('params', { params: params })
          })
          return;
        }
        else {
          window.startInAppPurchaseAndroid({
            productId: productId,
            trackingInformation: props.trackingInformation,
          })
        }
      }
      else {
        if(user && user.tokenId && tp && tp.user && tp.user.isUserValid() && tp.offer) {
          tp.offer.startCheckout(params);
        }
        else {
          tp.offer.close()
          setOfferParams(params)
          setShowLoginOverlay(true)
        }
      }
    }
  }, [user, props.article, props.trackingInformation, preSetSubscription])

  useEffect(() => {
    window.tikPianologinRequired = loginRequired
  }, [loginRequired])

  const resetSubscription = (productId) => {
    if(isPaidProductId(productId)) {
      //console.log("setSubscription.3")
      setSubscription({
        ...subscription,
        nnPlusApp: false
      })
      showOfferExecute()
    }
    if(isPurProductId(productId)) {
      //console.log("setSubscription.4")
      setSubscription({
        ...subscription,
        purApp: false
      })
      showPurOffer()
    }
  }

  useEffect(() => {
    window.inAppPurchaseCanceled = (termId: string) => {
      //console.log("inAppPurchaseCanceled " + termId)
      resetSubscription(termId)
    }
  }, [])

  const setJwt = useCallback((tokenId) => {
    let tp = window["tp"] || [];
    if(tp && tp.setExternalJWT) {
      if(tokenId) {
        tp.setExternalJWT(tokenId)
      }
      else {
        tp.setExternalJWT("123456")
      }
    }
  }, [])

  useEffect(() => {
    validate()
  },[setJwt, user, validate])

  useEffect(() => {
    if(user) {
      setJwt(user.tokenId)
    }
    else {
      setJwt("")
    }
  },[user, setJwt])

  const toggleRegister = useCallback(() => {
    setShowRegister(!showRegister)
  }, [showRegister])

  const setUserInternal = useCallback((userValue) => {
    setUser(userValue)
    if(userValue) {
      validateLoginParams(userValue.tokenId)
    }
    else {
      showOfferExecute()
    }
  }, [setUser, validateLoginParams])

  const closeRegisterLogin = () => {
    setShowRegister(false)
    setShowLoginOverlay(false)
  }

  const doLoadPiano = useCallback(() => {
    if(props?.pianoSwitchConfiguration?.pianoOff) {
      return false;
    }
    return true;
  }, [props?.pianoSwitchConfiguration?.pianoOff])

  return (
    <React.Fragment>
      { doLoadPiano() && <PianoScript></PianoScript> }
     {showLoginOverlay && !showRegister &&
        <Modal onClose={() => {closeRegisterLogin();validateLoginParams("");}}>
          {!user &&
            <UserSignedOut toggleRegister={toggleRegister} user={user} setUser={(userValue) => { setUserInternal(userValue);closeRegisterLogin()}} showCustomize={false}/>
          }
          {user && 
            <React.Fragment>
              <div className="user-login flex flex-col px-6 pt-10">
                <h2 className="mb-4 text-center font-lato text-xl">Login</h2>
              </div>         
              <div className="mb-4 text-center p-6 py-8 border-t border-border">
                <div className="mb-4">Ein Fehler ist aufgetreten.</div>
                <Link href='#' onClick={(e) => { e.preventDefault(); setUser(null) }} className="btn btn-light w-full">
                  {/* <a onClick={(e) => { e.preventDefault(); setUser(null) }} className="btn btn-light w-full"> */}
                    Ausloggen
                  {/* </a> */}
                </Link>
              </div>
            </React.Fragment>
          }
          </Modal>
        }
      {showRegister && 
        <Modal onClose={() => {setShowRegister(false)}}>
          <UserRegister setUser={(user) => {setUser(user);}} toggleOverlay={() => { 
            if(!user || !user.tokenId) {
              toggleRegister()
             }
             else {
              closeRegisterLogin();
              // console.log("toggleOverlay: " + user.tokenId)
              validateLoginParams(user.tokenId);
          }}} />
        </Modal>
      }
    </React.Fragment>)
}